import { toast_configs } from "@core/constants/toast_configs";

// جمله‌ی پیش‌فرض همه‌ی خطاهای میوتیشن: کوتاه، غیرفنی و با یک راهکار روشن.
export const DEFAULT_MUTATION_ERROR_MESSAGE =
    "درخواست شما انجام نشد. لطفاً چند لحظه دیگر دوباره تلاش کنید.";

const AUTH_ERROR_MESSAGE = "برای انجام این کار ابتدا وارد حساب کاربری خود شوید.";

const THROTTLE_ERROR_MESSAGE =
    "تعداد تلاش‌های شما زیاد است، لطفاً کمی بعد دوباره تلاش کنید.";

// پیام‌های سرور همیشه قابل نمایش نیستند؛ کلیدهایی مثل `invalid_token` یا
// `required` هم از همین مسیر می‌آیند. پس فقط پیامی که فارسی نوشته شده باشد به
// کاربر نشان داده می‌شود و بقیه به جمله‌ی پیش‌فرض تبدیل می‌شوند.
const PERSIAN_LETTER = /[\u0600-\u06FF]/;

const user_facing_message = (value) => {
    const text = typeof value === "string" ? value.trim() : "";

    return PERSIAN_LETTER.test(text) ? text : "";
};

// خطاهای فیلدی به شکل { mobile: ["required"], code: "incorrect" } برمی‌گردند و
// در فرم‌ها زیر همان اینپوت نمایش داده می‌شوند.
export const has_field_errors = (errors) =>
    Object.keys(errors?.[0]?.errors || {}).length > 0;

const first_field_message = (errors) => {
    const field_errors = errors?.[0]?.errors || {};

    for (const value of Object.values(field_errors)) {
        const message = user_facing_message(Array.isArray(value) ? value[0] : value);

        if (message) return message;
    }

    return "";
};

export const get_mutation_error_message = (errors, fallback) => {
    const code = String(errors?.[0]?.code ?? "");

    if (code === "401") return AUTH_ERROR_MESSAGE;
    if (code === "403") return THROTTLE_ERROR_MESSAGE;

    return (
        user_facing_message(errors?.[0]?.message) ||
        first_field_message(errors) ||
        user_facing_message(fallback) ||
        DEFAULT_MUTATION_ERROR_MESSAGE
    );
};

/**
 * توست خطای میوتیشن‌ها. مستقیم هم می‌شود به `error_callback` پاس داد:
 *   error_callback: show_mutation_error_toast
 *
 * @param errors آرایه‌ی خطای برگشتی از میوتیشن (`result.errors`)
 * @param options.message جمله‌ی جایگزین پیش‌فرض، فقط برای همین فراخوانی
 * @param options.skip_field_errors وقتی خطا فیلدی است و فرم خودش آن را زیر
 *   اینپوت نشان می‌دهد، توست تکراری نمایش داده نشود
 * @param options.toast_options تنظیمات اضافه‌ی react-toastify
 */
export const show_mutation_error_toast = (errors, options = {}) => {
    const {
        message,
        skip_field_errors = false,
        toast_options = {},
    } = options && typeof options === "object" ? options : {};

    if (skip_field_errors && has_field_errors(errors)) return;

    return toast_configs(get_mutation_error_message(errors, message), "error", {
        className: "toast-general-style",
        position: "bottom-center",
        autoClose: 4000,
        ...toast_options,
    });
};
